import component from './component/'
import Vue from 'vue'
import { ref } from '@vue/composition-api'

export const defaultSrc = ref(null)

export default ({ defaultSrc: _defaultSrc }) => {
  defaultSrc.value = _defaultSrc
  Vue.component(`feature-avatar`, component)
}
